import '@draft-js-plugins/static-toolbar/lib/plugin.css';
import './useEditorToolbar.scss';
import createLinkifyPlugin from '@draft-js-plugins/linkify';
import { EditorPlugin } from '@draft-js-plugins/editor';
import {
	BoldButton,
	HeadlineOneButton,
	HeadlineThreeButton,
	HeadlineTwoButton,
	ItalicButton,
	OrderedListButton,
	UnderlineButton,
	UnorderedListButton
} from '@draft-js-plugins/buttons';
import createEmojiPlugin, { EmojiPlugin } from '@draft-js-plugins/emoji';
import createToolbarPlugin, { StaticToolBarPlugin } from '@draft-js-plugins/static-toolbar';
import React, { useMemo } from 'react';

interface EditorToolbarHook {
	plugins: (EmojiPlugin | StaticToolBarPlugin | EditorPlugin)[];
	toolbar: JSX.Element;
}

export const useEditorToolbar = (): EditorToolbarHook => {
	const { EmojiSelect, EmojiSuggestions, Toolbar, plugins } = useMemo(() => {
		const emojiSymbol = '😀';
		const staticToolbarPlugin = createToolbarPlugin();
		const linkifyPlugin = createLinkifyPlugin({
			component(props) {
				return (
					<a
						{ ...props }
						onClick={ () => window.open(props.href) }>
						{ props.children }
					</a>
				);
			},
			rel: 'noopener',
			target: '_blank'
		});
		const emojiPlugin = createEmojiPlugin({
			selectButtonContent: <div className='grey-emoji'>{ emojiSymbol }</div>,
			useNativeArt: true
		});

		return {
			EmojiSelect: emojiPlugin.EmojiSelect,
			EmojiSuggestions: emojiPlugin.EmojiSuggestions,
			Toolbar: staticToolbarPlugin.Toolbar,
			plugins: [ staticToolbarPlugin, emojiPlugin, linkifyPlugin ]
		};
	}, []);

	const toolbar =
		<div className='toolbar'>
			<Toolbar>
				{ (externalProps) =>
					<>
						<BoldButton { ...externalProps } />
						<ItalicButton { ...externalProps } />
						<UnderlineButton { ...externalProps } />
						<div className='hTagButtons'>
							<HeadlineOneButton { ...externalProps } />
							<HeadlineTwoButton { ...externalProps } />
							<HeadlineThreeButton { ...externalProps } />
						</div>
						<UnorderedListButton { ...externalProps } />
						<OrderedListButton { ...externalProps } />
						<EmojiSuggestions />
						<div className='emoji-select'>
							<EmojiSelect />
						</div>
					</> }
			</Toolbar>
		</div>;

	return {
		plugins,
		toolbar
	};
};
